<!--
  - Copyright (c) 2019 Eva Novotná, Juraj Šimon
  -->

<template>
  <router-view></router-view>
</template>

<script>
export default {
  metaInfo: {
    title: "Eva Novotna",
    //titleTemplate: '%s - Yay!',
    meta: { charset: "utf-8" },
    htmlAttrs: {
      lang: localStorage.getItem("language") || "en",
      amp: false
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./styles/main";

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
